'use client';

import { getDomainSource, SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { useCallback } from 'react';
import { useNavigate } from '../../common/hooks/useNavigate';

/**
 * 상품 PDP/링크 진입 전용 navigation.
 *
 * - 29CM 인앱 + 29CM 도메인 PDP: native 앱바 노출을 위해 fullscreen 쿼리 끔.
 * - 그 외(외부 브랜드 사이트 / 무신사 환경 / 웹): 기존 navigate 동작 그대로.
 *
 * `linkUrl` 은 API 응답에서 `z.string()` 으로만 보장 — 외부 브랜드 사이트가 들어올 수
 * 있어 무차별 쿼리 부착은 부적절. 환경(사용자 service) + 타깃 도메인 이중 가드.
 */
export const useProductLinkNavigation = () => {
  const { navigate } = useNavigate();
  const { service } = useDeviceInfo();

  return useCallback(
    (productUrl: string) => {
      let is29cmTarget = false;
      try {
        const targetHost = new URL(productUrl, window.location.origin).hostname;
        is29cmTarget = getDomainSource(targetHost) === SERVICE['29CM'];
      } catch {
        // 잘못된 URL — 가드 끄고 기존 navigate 가 처리.
      }

      navigate(productUrl, {
        newWebview: true,
        disableFullscreen: service === SERVICE['29CM'] && is29cmTarget,
      });
    },
    [navigate, service],
  );
};
